<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-colleges">
  <div class="p-30" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Collèges électoraux et répartition</p>
        <p class="no-margin dark-gray text-sm">Configuration de chaque collège électoral</p>
      </div>
    </div>
  </div>

  <div class="p-30 flex flex-column gap-30">
    <div *ngFor="let college of colleges; let i = index">
      <p class="dark-red" *ngIf="lineupErrorMessage.length != 0">{{lineupErrorMessage}}</p>
      <div class="p-10 bg-light-gray" style="border: solid 1px #F0F5FF;"
        [style.border-color]="lineupErrorMessage.length != 0 ? '#D70040' : '#F0F5FF'">
        <p class="light-blue bold">College {{i + 1}}</p>
        <app-one-college [(college)]="colleges[i]" (collegeChange)="onCollegeChange()" [index]="i"
          [lineupErrorMessage]="lineupErrorMessage" [partial]="partial"
          [remainingEmployee]="remainingEmployee"></app-one-college>
      </div>
    </div>
  </div>
</div>